module.exports = __webpack_public_path__ + "img/remove-card.698f8a91.svg";